import TenantApi from '../../api/TenantApi';

const state = {
   pageTitle: process.env.VUE_APP_APP_NAME,
   tenant: null,
};

const getters = {
   pageTitle(state) {
      return state.pageTitle;
   },
   tenant(state) {
      return state.tenant;
   },
};

const actions = {
   async setPageTitle(context, pageTitle) {
      document.title = pageTitle;

      context.commit('pageTitle', pageTitle);
   },
   async tenant(context) {
      const response = await TenantApi.config();
      context.commit('tenant', response);
   },
};

const mutations = {
   pageTitle(state, pageTitle) {
      state.pageTitle = pageTitle;
   },
   tenant(state, tenant) {
      state.tenant = tenant;
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
